<script lang="ts" setup>
import { useCityStore } from '~/store/city'
import type { City } from '~/types/city'

defineProps<{
  city: City
}>()

const cityStore = useCityStore()

function selectCity (city: City): void {
  cityStore.setCity(city)
  cityStore.closeCityPopup()
}
</script>

<template>
  <li>
    <button
      class="
        w-full rounded-lg px-4 py-2 text-left transition-colors duration-150 hover:bg-green-50 hover:text-main-green
      "
      :class="{ 'bg-green-100 text-main-green': city.id === cityStore.selectedCity.id }"
      @click="selectCity(city)"
    >
      {{ city.name }}
    </button>
  </li>
</template>
